(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var body = document.body;
    if (!body.classList.contains('stilloak-home')) {
      return;
    }

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealItems = document.querySelectorAll('.stilloak-home .reveal');

    if (!reducedMotion && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('visible');
      });
    }

    var header = document.querySelector('.site-header');
    var heroShape = document.querySelector('.hero-bg-shape');
    var heroCircle = document.querySelector('.hero-bg-circle');
    var ticking = false;

    function onScroll() {
      if (header) {
        header.classList.toggle('scrolled', window.scrollY > 50);
      }

      if (reducedMotion || !heroShape || ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(function () {
        var scrollY = window.pageYOffset;
        if (scrollY < window.innerHeight) {
          heroShape.style.transform = 'translateY(' + scrollY * 0.12 + 'px)';
          if (heroCircle) {
            heroCircle.style.transform = 'translateY(' + scrollY * 0.06 + 'px)';
          }
        }
        ticking = false;
      });
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = document.querySelector('.mobile-toggle');
    var menu = document.querySelector('.mobile-menu');
    var overlay = document.querySelector('.mobile-overlay');
    var menuClose = document.querySelector('.mobile-menu-close');

    if (toggle && menu && overlay) {
      function closeMenu() {
        toggle.classList.remove('active');
        menu.classList.remove('open');
        overlay.classList.remove('open');
        body.classList.remove('menu-open');
      }

      function openMenu() {
        toggle.classList.add('active');
        menu.classList.add('open');
        overlay.classList.add('open');
        body.classList.add('menu-open');
      }

      toggle.addEventListener('click', function () {
        if (toggle.classList.contains('active')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      if (menuClose) {
        menuClose.addEventListener('click', closeMenu);
      }

      overlay.addEventListener('click', closeMenu);
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 992) {
          closeMenu();
        }
      });
    }
  });
})();
